<template>
  <b-nav-item-dropdown variant="link" no-caret right class="text-left">
    <template v-slot:button-content>
      <icool-icon icon="settings" />
    </template>
    <b-dropdown-item
      :to="{ name: 'settings-user' }"
      >
      <font-awesome-icon icon="user" />
      {{ getUsername }}
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      v-for="(item, index) in settingItems"
      :key="index"
      :to="item.to"
    >
    <font-awesome-icon :icon="item.icon" />
    {{ item.name }}
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      @click="reloadSnapshot"
    >
      <font-awesome-icon icon="sync-alt" />
      {{ $t('reload-project') }}
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      @click="logout"
    >
      <font-awesome-icon icon="sign-out-alt" />
      {{ $t('logout') }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import SettingsItemsMixin from '@/components/navigation/top-navigation/SettingsItemsMixin';
import config from '@/config';
import { mapGetters } from 'vuex';
import eventBus from '@/components/utils/slideout-panel/eventBus';


export default {
  name: 'SettingsDropDownMenu',
  mixins: [
    SettingsItemsMixin,
  ],
  data() {
    return {
      baseSettingItems: [
      ],
      superUsersSettingItems: [
        {
          to: { name: 'users-management' },
          name: this.$t('users-management'),
          icon: 'users',
        },
        {
          to: {},
          name: this.$t('licence-and-services'),
          icon: 'file-alt',
        },
        {
          to: { name: 'plc-connection-settings' },
          name: this.$t('plc-connection-settings'),
          icon: 'wifi',
        },
        {
          to: { name: 'user-api-token-settings' },
          name: this.$t('user-api-token-settings'),
          icon: 'key',
        },
        {
          to: { name: 'subscription' },
          name: this.$t('subscription'),
          icon: 'file-invoice',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', [
      'getUserData',
    ]),
    settingItems() {
      const items = Array.from(this.baseSettingItems);
      if (this.getUserData.superuser) {
        items.push(...this.superUsersSettingItems);
      }
      return items;
    },
    getUsername() {
      if (!this.getUserData.user) {
        return '';
      }
      if (this.getUserData.user.first_name && this.getUserData.user.last_name) {
        return `${this.getUserData.user.first_name} ${this.getUserData.user.last_name}`;
      }
      return this.getUserData.user.username;
    },
  },
  methods: {
    logout() {
      window.location.href = `${config.ICOOL.BACKEND_HOST}/${config.ICOOL.LOGOUT_URL}`;
    },
    reloadSnapshot() {
      eventBus.$emit('refreshSnapshot');
    },
  },
};
</script>

<style scoped>

</style>
